module.exports = __webpack_public_path__ + "contatore-d-e4o.png";